webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(27),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var el = _ref.el,
        _ref$attr = _ref.attr,
        attr = _ref$attr === undefined ? 'background-position-y' : _ref$attr,
        _ref$speed = _ref.speed,
        speed = _ref$speed === undefined ? 5 : _ref$speed,
        _ref$unit = _ref.unit,
        unit = _ref$unit === undefined ? 'px' : _ref$unit;


    var element = document.querySelector(el);

    if (element) {
        (function () {
            var setParallax = function setParallax() {

                var wScroll = window.pageYOffset;

                function animate() {
                    element.style[attr] = Math.ceil(wScroll / speed) + unit;
                }

                if (wScroll <= elScrollDistance) {

                    window.requestAnimationFrame(animate);
                }
            };

            // Height Calctulations
            var elHeight = element.clientHeight,
                elOffset = element.offsetTop,
                elScrollDistance = elHeight + elOffset;

            window.addEventListener('scroll', setParallax);
        })();
    }
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(7);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(2);

var _vuex2 = _interopRequireDefault(_vuex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
    actions: {
        confirmAge: function confirmAge(_ref, payload) {
            var commit = _ref.commit;

            commit('confirmAge', payload);
        },
        openPopup: function openPopup(_ref2, payload) {
            var commit = _ref2.commit;

            commit('openPopup', payload);
        },
        closePopup: function closePopup(_ref3, payload) {
            var commit = _ref3.commit;

            commit('closePopup', payload);
        }
    },

    getters: {
        ageConfirmed: function ageConfirmed(state) {
            return state.ageConfirmed;
        },

        popupShown: function popupShown(state) {
            return state.popupShown;
        }

    },

    mutations: {
        confirmAge: function confirmAge(state, message) {
            state.ageConfirmed = true;
        },
        openPopup: function openPopup(state, message) {
            state.popupShown = true;
        },
        closePopup: function closePopup(state, message) {
            state.popupShown = false;
        }
    },

    state: {
        ageConfirmed: false,
        underAge: false,
        popupShown: false
    }
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (_ref) {
    var el = _ref.el,
        _ref$boundry = _ref.boundry,
        boundry = _ref$boundry === undefined ? 'top' : _ref$boundry,
        _ref$offset = _ref.offset,
        offset = _ref$offset === undefined ? 0 : _ref$offset,
        cb = _ref.cb;


    var element = document.querySelector(el);

    if (element) {
        (function () {
            var getScrollOverElement = function getScrollOverElement() {

                if (window.pageYOffset >= elWithOffset) {

                    cb(element);

                    window.removeEventListener('scroll', getScrollOverElement);
                }
            };

            var scrollTop = window.pageYOffset,
                elBoundry = element.getBoundingClientRect()[boundry],
                windowHeight = window.innerHeight,
                elDistanceTop = Math.round(elBoundry - windowHeight),
                elWithOffset = elDistanceTop + offset;

            getScrollOverElement();

            window.addEventListener('scroll', getScrollOverElement);
        })();
    }
};

/***/ }),
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(7);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(37);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vuex = __webpack_require__(2);

var _store = __webpack_require__(4);

var _store2 = _interopRequireDefault(_store);

var _ageConfirmation = __webpack_require__(24);

var _ageConfirmation2 = _interopRequireDefault(_ageConfirmation);

var _popupGame = __webpack_require__(26);

var _popupGame2 = _interopRequireDefault(_popupGame);

var _einkehren = __webpack_require__(21);

var _einkehren2 = _interopRequireDefault(_einkehren);

var _biere = __webpack_require__(19);

var _biere2 = _interopRequireDefault(_biere);

var _bierkulTour = __webpack_require__(20);

var _bierkulTour2 = _interopRequireDefault(_bierkulTour);

var _kulturGenuss = __webpack_require__(23);

var _kulturGenuss2 = _interopRequireDefault(_kulturGenuss);

var _bayronMan = __webpack_require__(18);

var _bayronMan2 = _interopRequireDefault(_bayronMan);

var _game = __webpack_require__(22);

var _game2 = _interopRequireDefault(_game);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
    routes: [{ path: '/', component: _ageConfirmation2.default }, { path: '/einkehren', component: _einkehren2.default }, { path: '/biere', component: _biere2.default }, { path: '/bierkul-tour', component: _bierkulTour2.default }, { path: '/kultur-genuss', component: _kulturGenuss2.default }, { path: '/bayron-man', component: _bayronMan2.default }, { path: '/gewinnspiel', component: _game2.default }],
    mode: 'history',
    linkActiveClass: 'is-current'
});

// router.beforeEach((to, from, next) => {
//
//     if( to.path !== from.path ) {
//
//         if( store.state.ageConfirmed ) {
//             next()
//         }
//         else {
//             //router.push({ path: '/biere', query: { from } })
//             next({ path: '/', query: { confirm: to.path.slice(1) } }) // remove slash
//             //next('/')
//         }
//     }
//     else {
//         next()
//     }
//
//
// })


new _vue2.default({
    router: router,
    store: _store2.default,
    components: { popupGame: _popupGame2.default },

    beforeRouteEnter: function beforeRouteEnter(to, from, next) {

        console.log(this);
        if (ageConfirmed) {
            next();
        } else {
            router.push({ path: '/', query: { from: from } });
        }
    },


    computed: (0, _vuex.mapGetters)(['ageConfirmed']),

    el: '#app',
    data: {
        askAge: true
    },

    methods: {
        subIsActive: function subIsActive(input) {
            var _this = this;

            var paths = Array.isArray(input) ? input : [input];
            return paths.some(function (path) {
                return _this.$route.path.indexOf(path) === 0; // current path starts with this path string
            });
        }
    }

});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _setParallax = __webpack_require__(3);

var _setParallax2 = _interopRequireDefault(_setParallax);

var _getScrollOverElement = __webpack_require__(5);

var _getScrollOverElement2 = _interopRequireDefault(_getScrollOverElement);

var _footer = __webpack_require__(1);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { appFooter: _footer2.default },

    mounted: function mounted() {

        this.$nextTick(function () {

            (0, _setParallax2.default)({
                el: '[class^="hero"]',
                attr: 'background-position-y',
                speed: 10
            });

            (0, _getScrollOverElement2.default)({
                el: '#logo-animated',
                offset: 350,
                cb: function cb(el) {
                    el.classList.add('is-revealed');
                }
            });
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getScrollOverElement = __webpack_require__(5);

var _getScrollOverElement2 = _interopRequireDefault(_getScrollOverElement);

var _setParallax = __webpack_require__(3);

var _setParallax2 = _interopRequireDefault(_setParallax);

var _vuex = __webpack_require__(2);

var _store = __webpack_require__(4);

var _store2 = _interopRequireDefault(_store);

var _featuredProducts = __webpack_require__(25);

var _featuredProducts2 = _interopRequireDefault(_featuredProducts);

var _footer = __webpack_require__(1);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {

    components: { featuredProducts: _featuredProducts2.default, appFooter: _footer2.default },

    mounted: function mounted() {

        this.$nextTick(function () {

            (0, _setParallax2.default)({
                el: '[class^="hero"]',
                speed: 10
            });

            (0, _getScrollOverElement2.default)({
                el: '.featured-box',
                offset: 400,
                cb: function cb() {

                    var bottles = document.querySelectorAll('.featured-item__bottle');

                    var _loop = function _loop(i) {
                        setTimeout(function () {
                            bottles[i].classList.add('is-inview');
                        }, 200 * i);
                    };

                    for (var i = 0; i < bottles.length; i++) {
                        _loop(i);
                    }
                }
            });
        });
    }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _setParallax = __webpack_require__(3);

var _setParallax2 = _interopRequireDefault(_setParallax);

var _footer = __webpack_require__(1);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: { appFooter: _footer2.default },

    mounted: function mounted() {

        this.$nextTick(function () {

            (0, _setParallax2.default)({
                el: '[class^="hero"]',
                attr: 'background-position-y',
                speed: 10
            });
        });
    }
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _owl = __webpack_require__(17);

var _owl2 = _interopRequireDefault(_owl);

var _vuex = __webpack_require__(2);

var _store = __webpack_require__(4);

var _store2 = _interopRequireDefault(_store);

var _setParallax = __webpack_require__(3);

var _setParallax2 = _interopRequireDefault(_setParallax);

var _getScrollOverElement = __webpack_require__(5);

var _getScrollOverElement2 = _interopRequireDefault(_getScrollOverElement);

var _footer = __webpack_require__(1);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {

    components: { appFooter: _footer2.default },

    computed: (0, _vuex.mapGetters)(['ageConfirmed']),

    data: function data() {
        return {
            underAge: false
        };
    },
    created: function created() {

        this.$nextTick(function () {
            createSlider();
        });
        //setTimeout(() => this.showPopup = true, 4000)
    },
    mounted: function mounted() {

        this.$nextTick(function () {

            (0, _setParallax2.default)({
                el: '[class^="hero"]',
                attr: 'background-position-y',
                speed: 10
            });
        });
    },


    methods: {}

};


function createSlider() {

    $('.slider').owlCarousel({
        items: 1,
        nav: true,
        lazy: false,
        dots: false,
        autoplay: true,
        loop: true,
        animateOut: 'owl-animated-out',
        animateIn: 'owl-animated-in',
        navText: ['‹', '›']

    });
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getScrollOverElement = __webpack_require__(5);

var _getScrollOverElement2 = _interopRequireDefault(_getScrollOverElement);

var _footer = __webpack_require__(1);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {

    components: { appFooter: _footer2.default },

    data: function data() {
        return {
            step: 1,
            showError: false
        };
    },
    mounted: function mounted() {

        setTimeout(function () {
            document.querySelector('#logo-animated').classList.add('is-revealed');
        }, 500);
    },


    methods: {
        validateQuestions: function validateQuestions() {

            var disziplin = document.querySelectorAll('input[name=disziplin]:checked'),
                getraenk = document.querySelectorAll('input[name=getraenk]:checked');

            if (disziplin.length == 0 || getraenk.length == 0) {
                this.showError = true;
                return;
            }

            this.showError = false;
            this.step = 2;
        },
        showAnswer: function showAnswer() {

            document.querySelector('.form-answer').classList.add('is-shown');
        }
    }

};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _setParallax = __webpack_require__(3);

var _setParallax2 = _interopRequireDefault(_setParallax);

var _footer = __webpack_require__(1);

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    components: { appFooter: _footer2.default },

    mounted: function mounted() {

        this.$nextTick(function () {

            (0, _setParallax2.default)({
                el: '[class^="hero"]',
                attr: 'background-position-y',
                speed: 10
            });
        });
    }
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__(2);

var _store = __webpack_require__(4);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    data: function data() {
        return {
            underAge: false
        };
    },


    computed: {
        destination: function destination() {
            return this.$route.query.confirm || 'einkehren';
        }
    },

    beforeRouteLeave: function beforeRouteLeave(to, from, next) {

        _store2.default.dispatch('confirmAge');

        next();
    }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__(2);

var _store = __webpack_require__(4);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {

    computed: (0, _vuex.mapGetters)(['popupShown', 'ageConfirmed']),

    data: function data() {
        return {};
    },


    watch: {
        ageConfirmed: function ageConfirmed() {
            setTimeout(function () {
                return _store2.default.dispatch('openPopup');
            }, 4000);

            setTimeout(function () {
                return _store2.default.dispatch('closePopup');
            }, 15000);
        },
        popupShown: function popupShown() {
            this.$nextTick(function () {
                document.body.addEventListener('click', function () {
                    return _store2.default.dispatch('closePopup');
                });
                document.querySelector('.popup').addEventListener('click', function (e) {
                    return e.stopPropagation();
                });
            });
        }
    },

    methods: {
        closePopup: function closePopup() {
            _store2.default.dispatch('closePopup');
        },
        closePopupAndRedirect: function closePopupAndRedirect() {
            this.closePopup();
            this.$router.push('/gewinnspiel');
        }
    }

};

/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(29),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(32),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(33),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(12),
  /* template */
  __webpack_require__(28),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(35),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(34),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(31),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(30),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(36),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('address', [_c('p', [_c('b', [_vm._v("Privatbrauerei Zissel")]), _c('br'), _vm._v("\n                Im Grund 15"), _c('br'), _vm._v("\n                92341 Kulmbach"), _c('br'), _vm._v("\n                Inhaber: Peter Gröger"), _c('br'), _vm._v("\n                Telefon: (0 92 14) 13 24 53"), _c('br'), _vm._v("\n                Fax: (0 92 14) 13 24 55"), _c('br'), _vm._v("\n                E-Mail: "), _c('a', {
    attrs: {
      "href": "mailto:peter.groeger@zisselbier.de"
    }
  }, [_vm._v("peter.groeger@zisselbier.de")])])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Aufgabenstellung:")]), _c('br'), _vm._v("\n            Zentral-Fachausschuss"), _c('br'), _vm._v("\n            Berufsbildung Druck und Medien"), _c('br'), _vm._v("\n            Wilhelmshöher Allee 260"), _c('br'), _vm._v("\n            34131 Kassel\n        ")])])])
}]}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap page-einkehren"
  }, [_c('header', {
    staticClass: "hero--index"
  }, [_vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "biere"
    }
  }, [_c('span', [_vm._v("Erkunde Zissel")])])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "hero-heading"
  }, [_c('small', [_vm._v("Braukunst aus Oberfranken")]), _vm._v("\n            Zissel\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--interlude"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col sm-8"
  }, [_c('h2', [_vm._v("Kultige Atmosphäre")]), _vm._v(" "), _c('p', [_vm._v("in einer typischen Gasthausbrauerei\n                        und fränkische Küche: "), _c('b', [_vm._v("Zissel verbindet.")])]), _vm._v(" "), _c('p', [_vm._v("\n                        Nach einer sportlichen Fahrradtour durch das Frankenland, einer Wanderung\n                        oder wann immer Sie mögen:\n                        Kehren Sie bei uns ein – in unseren Biergarten,\n                        in den kühlen Braukeller oder in unsere neue Erlebniskneipe. Hier fühlt man sich wohl!\n                    ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--light"
  }, [_c('div', {
    staticClass: "slider"
  }, [_c('div', {
    staticClass: "slider-item"
  }, [_c('div', {
    staticClass: "slider-image"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/einkehren-slider-1.jpg",
      "alt": "Anwesen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slider-text"
  }, [_c('h2', [_vm._v("Unsere Privatbrauerei\n                        "), _c('small', [_vm._v("\n                            am Rande von Kulmbach besteht seit 1898.\n                        ")])]), _vm._v(" "), _c('p', [_vm._v("Zum Anwesen gehören Brauerei, Gaststätte mit Biergarten,\n                        Brennerei und ein Gästehaus.")])])]), _vm._v(" "), _c('div', {
    staticClass: "slider-item"
  }, [_c('div', {
    staticClass: "slider-image"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/einkehren-slider-2.jpg",
      "alt": "Brauen"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slider-text"
  }, [_c('h2', [_vm._v("Unsere Qualitätsbiere\n                        "), _c('small', [_vm._v("\n                            werden mit Wasser aus eigenem\n                            Tiefbrunnen nach dem Bayerischen Reinheitsgebot gebraut.\n                        ")])]), _vm._v(" "), _c('p', [_vm._v("Probieren Sie das erfrischend herbe Helle, das untergärige Dunkle,\n                        unser Rauchbier oder unser Ungespundetes.")])])]), _vm._v(" "), _c('div', {
    staticClass: "slider-item"
  }, [_c('div', {
    staticClass: "slider-image"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/einkehren-slider-3.jpg",
      "alt": "Gerichte"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "slider-text"
  }, [_c('h2', [_vm._v("Und weil zu fränkischem Bier\n                        "), _c('small', [_vm._v("\n                            nun mal nichts so\n                            gut passt wie die echte fränkische Küche,\n                            servieren wir regional typische und köstliche Gerichte.\n                        ")])]), _vm._v(" "), _c('p', [_vm._v("Auf Ihr Wohl!")])])])])])
}]}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap page-bayron-man"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "section--light poster"
  }, [_c('header', {
    staticClass: "poster__header"
  }, [_c('svg', {
    staticClass: "logo-animated",
    attrs: {
      "id": "logo-animated",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 894.294 870.151"
    }
  }, [_c('path', {
    staticClass: "bottle",
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M490.141,559.871c.042-10.789,2.054-25.236,5.13-37.571,1.489-5.966,36.551-146.926,36.551-207.754,0-61.147-12.013-97.891-12.52-99.425a8.19,8.19,0,0,0-7.778-5.612H390.477a8.2,8.2,0,0,0-8.039,6.59c-.5,2.5-12.26,61.743-12.26,98.442,0,60.828,35.066,201.788,36.56,207.759,5.186,20.779,7.343,47.546,2.158,52.736-14.1,14.1-14.5,28.414-14.5,30a8.2,8.2,0,0,0,8.2,8.2h96.832a8.186,8.186,0,0,0,8.2-8.2c0-1.588-.426-15.907-14.512-30Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M68.672,178.092c-.228.8-1.37,5.368-2.4,10.05s-2.512,11.078-3.426,14.275c-9.022,33.918-10.164,59.271-3.312,77.315C64.675,293.666,67.53,298.8,69.7,298.8c2.741.114,13.933-18.044,18.5-30.15,7.309-18.843,7.652-20.557,7.652-38.372.114-17.93-.114-18.729-7.652-33.918a53.656,53.656,0,0,0-10.164-13.476c-6.51-6.281-8.679-7.309-9.365-4.8Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M823.782,181.519c-8.679,8.223-13.248,15.075-17.016,26.267-3.312,9.593-3.54,34.375-.457,44.882,5.824,19.986,20.1,46.709,24.439,45.91,1.6-.228,6.167-8.223,9.136-15.646,2.512-6.51,5.824-24.554,5.824-31.977,0-8.794-3.312-28.208-8.565-49.107-.8-3.426-2.512-10.392-3.655-15.3-1.256-5.025-2.627-9.25-3.312-9.479-.571-.228-3.426,1.827-6.4,4.454Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M13.855,262.032c-1.142,1.142-.8,14.275.457,21.013.685,3.426,1.713,10.278,2.284,15.3,2.512,22.955,9.136,46.709,17.587,63.383,6.51,13.019,21.47,28.437,27.751,28.551,2.17,0,2.512-.8,3.312-7.766,1.827-17.587-.8-46.823-6.053-65.324-6.966-25.01-20.1-44.882-33.69-51.163C17.4,262.374,14.54,261.346,13.855,262.032Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M881.111,263.059c-9.936,3.2-20.9,12.9-27.751,24.325-13.476,22.726-21.013,60.413-18.5,92.619.914,11.649,1.941,12.562,8.908,7.766,16.445-11.42,26.609-29.236,34.261-59.728,3.2-12.448,5.368-23.983,5.368-27.409a100.66,100.66,0,0,1,1.713-12.334,115.987,115.987,0,0,0,1.713-17.473c0-8.908-.457-9.479-5.71-7.766Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M118.807,317.991C103.733,336.949,89.8,363.9,83.633,385.713c-4.8,16.674-5.368,20.442-5.368,35.517,0,19.529,2.17,26.838,11.306,38.6,3.654,4.682,4,4.8,5.482,2.855,1.6-2.17,19.757-38.943,22.955-46.138.914-2.17,2.4-5.482,3.2-7.195a14.555,14.555,0,0,0,1.6-5.025,12.553,12.553,0,0,1,1.6-4.682c1.713-3.312,4-10.621,6.738-21.356,4.454-17.359,5.368-33.347,2.627-46.252-1.6-7.994-6.966-20.557-8.794-20.557C124.4,311.481,121.662,314.451,118.807,317.991Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M772.961,314.565c-4.454,6.738-8.337,22.612-8.337,33.461.114,10.963,4.111,32.662,7.537,40.885a18.508,18.508,0,0,1,1.6,5.368,18.507,18.507,0,0,0,1.6,5.368c.914,2.056,2.741,6.624,4.111,10.05,6.852,17.13,25.125,53.675,26.838,53.675,3.083,0,10.164-10.621,13.59-20.328,1.713-4.8,2.17-9.479,2.056-21.47,0-16.217-1.37-24.1-6.738-39.857-1.6-4.454-3.2-9.593-3.769-11.42-4.111-13.362-31.748-58.814-35.86-58.814-.343,0-1.6,1.37-2.627,3.083Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M3.577,350.082c-1.37,1.256-.685,23.64,1.142,35.517,2.17,15.3,4.8,28.893,6.852,35.517,2.969,9.936,6.167,19.529,7.195,21.47,5.139,10.164,6.852,13.248,11.078,19.757,5.139,7.766,22.5,25.353,27.066,27.294,1.37.685,4.682,2.512,7.423,4.111,7.081,4.111,8.451,3.2,7.537-4.911-1.941-19.643-9.821-54.246-16.1-70.577-.914-2.512-2.512-6.624-3.54-9.136A127.06,127.06,0,0,0,44.8,393.136c-7.994-13.248-12.677-19.529-19.529-26.723-7.994-8.223-20.442-17.7-21.7-16.331Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M887.964,355.107c-10.164,7.652-15.075,12.562-22.27,22.155-14.39,18.958-25.01,45.567-31.863,79.257-2.512,12.334-5.025,27.066-5.71,33.461-.8,7.195.685,7.652,9.25,2.969,13.7-7.537,27.523-21.128,36.545-35.86,2.4-3.883,9.479-18.843,9.479-19.986a20.172,20.172,0,0,1,1.6-4.8c3.54-8.223,7.309-24.668,10.392-45.11,1.827-12.106,2.4-36.431.914-37.23-.571-.343-4.226,2.056-8.337,5.139Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M124.517,439.845a22.706,22.706,0,0,0-1.713,7.081,58.818,58.818,0,0,1-1.941,10.05c-2.855,10.735-2.855,61.784,0,73.775,5.025,20.442,7.423,27.18,14.5,42.255,6.852,14.618,21.356,36.545,24.1,36.545,2.512,0,5.71-9.022,7.88-22.27a79.217,79.217,0,0,1,2.4-10.849c2.284-8.223,1.941-52.191-.571-61.67-5.824-22.27-11.649-37.116-18.958-48.536a57.731,57.731,0,0,1-3.312-5.71c-1.827-3.769-17.7-23.754-19.3-24.325-.8-.228-2.17,1.37-3.083,3.655Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M764.853,444.756c-6.852,8.565-16.445,23.183-18.615,28.208a45.882,45.882,0,0,1-2.056,4.111c-4.111,6.966-9.593,22.955-13.362,38.715-2.4,10.278-2.741,51.049-.457,59.5.8,2.855,1.827,7.994,2.4,11.42,1.6,10.507,4.911,20.785,6.966,22.155,1.6.914,2.4.685,3.769-1.028,2.17-2.855,12.105-17.587,13.819-20.557,3.083-5.253,13.019-25.581,13.019-26.723a19.032,19.032,0,0,1,1.6-4.911C780.27,536,783.925,504.6,781.3,475.363c-.914-10.05-2.284-20.1-2.855-22.27a29.724,29.724,0,0,1-1.256-7.423c0-3.769-2.17-8.679-4.111-9.365-.685-.228-4.454,3.54-8.223,8.451Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M3.577,480.273c-1.028,1.6,3.883,16.9,8.794,27.637,8.108,17.93,25.581,35.4,48.422,48.536,4.911,2.855,9.707,5.71,10.621,6.281,7.309,4.34,45.224,22.841,46.937,22.841,1.941,0,2.17-.571,1.6-4.34-1.256-7.423-4.111-15.76-9.365-27.066-8.451-18.387-26.5-36.088-52.3-51.62C52.341,499,31.442,489.181,21.164,485.07a95.449,95.449,0,0,1-9.479-4.111C8.031,479.131,4.49,478.9,3.577,480.273Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M887.964,481.3c-2.17,1.028-5.71,2.512-7.652,3.312-8.451,3.54-11.991,5.025-15.532,6.51-5.482,2.4-19.3,9.479-23.754,12.106-2.17,1.37-4.682,2.741-5.6,3.2-1.6.685-5.253,3.312-15.417,10.849-6.281,4.8-19.986,19.3-23.983,25.467-4.454,7.081-11.991,22.726-11.991,25.01a23.273,23.273,0,0,1-1.713,5.6c-2.284,5.368-2.284,12.22-.114,12.22,1.37,0,43.283-20.785,53.219-26.381,20.9-11.877,39.514-28.551,48.765-43.854,5.71-9.365,13.819-32.434,12.334-34.832-1.028-1.6-3.883-1.256-8.565.8Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M29.843,569.466c-.685,1.028.343,4.8,1.485,5.824.343.343,1.941,2.4,3.54,4.568,13.933,19.986,41,45.567,59.957,56.645,3.083,1.827,6.738,3.883,7.994,4.682a49.611,49.611,0,0,0,4.911,2.627c1.485.571,5.253,2.284,8.565,3.769,16.674,7.652,32.548,11.763,54.475,14.5,12.334,1.485,12.562,1.485,12.562-.571,0-2.284-11.877-20.328-19.986-30.264-9.022-10.963-33.119-32.89-39.4-35.745-.914-.457-3.2-1.827-5.139-3.083-4.911-3.083-16.674-9.25-19.986-10.278-1.6-.571-5.6-2.056-9.022-3.312-9.365-3.54-23.3-6.624-36.659-8.108C31.785,568.438,30.528,568.324,29.843,569.466Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M861.7,569.123c-32.548,2.969-47.623,6.738-69.093,17.245-16.331,8.108-27.066,15.646-40.77,29.236-16.217,15.874-37.459,44.539-34.946,47.166.914.8,21.013-1.485,31.177-3.655,17.93-3.769,28.322-7.423,45.11-15.874,7.537-3.769,23.526-13.59,25.125-15.417.343-.343,2.855-2.4,5.71-4.568,12.105-9.136,27.409-25.01,38.715-39.971,8.794-11.763,9.593-13.362,7.423-14.161a8.064,8.064,0,0,0-3.083-.457c-.8,0-3.2.343-5.368.457Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M185.159,573.805c-2.17,2.284,2.627,31.177,7.423,45.453a68.312,68.312,0,0,1,2.17,6.852c2.056,7.195,8.451,22.955,11.42,27.98.571.914,2.284,4.111,3.883,7.081,3.654,6.738,10.392,17.245,12.334,19.3.8.914,3.769,4.454,6.624,7.88a180.224,180.224,0,0,0,38.943,34.6c6.738,4.454,8.908,5.139,9.136,2.741,1.37-15.76-4.8-48.422-12.791-67.608A251.067,251.067,0,0,0,253,635.247c-1.256-1.941-2.627-4.226-3.083-5.139C248.085,626,238.149,614,229.7,605.44c-8.451-8.451-26.838-23.3-28.779-23.3a5.658,5.658,0,0,1-2.627-1.6c-3.083-2.627-12.448-7.423-13.133-6.738Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M710.378,575.4c-1.827,1.142-4.226,2.512-5.139,2.969s-4,2.284-6.852,4.226c-18.729,12.448-37.687,30.949-47.508,46.366-9.136,14.5-18.272,34.832-21.013,46.823-.457,2.17-1.37,6.281-2.056,9.136-3.312,13.476-4.8,23.754-4.8,32.434,0,5.139.343,9.707.685,10.164,1.713,1.713,25.467-16.1,37.573-28.322,17.016-17.016,27.751-33.233,38.715-58.243,9.136-20.785,18.5-63.383,14.846-66.809C714.261,573.691,712.32,574.262,710.378,575.4Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M110.813,664.482c-7.423.914-14.732,3.312-16.788,5.368a4.524,4.524,0,0,1-2.627,1.37c-1.827,0-6.281,4.911-6.281,7.081,0,1.37,17.016,13.59,23.983,17.245a54.372,54.372,0,0,1,5.139,3.083c1.941,1.256,4.454,2.741,5.71,3.426s5.368,2.969,9.136,5.139c8.223,4.8,34.489,17.7,41.684,20.557,2.855,1.142,6.738,2.627,8.565,3.426a96.756,96.756,0,0,0,9.707,3.2c3.426,1.028,9.365,2.627,13.133,3.769,10.164,2.855,37,2.969,43.968,0,7.766-3.2,8.565-3.655,8.908-5.6.457-2.284-14.39-15.417-32.662-28.665-3.883-2.855-7.309-5.253-7.537-5.253a59.611,59.611,0,0,1-7.195-4.34c-7.081-4.8-8.108-5.368-21.7-11.991-15.3-7.652-28.437-12.9-34.6-14.161-1.6-.343-5.139-1.256-7.994-2.056-6.51-1.941-23.64-2.741-32.548-1.6Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M767.48,664.368a112.665,112.665,0,0,0-27.98,6.966c-3.426,1.256-7.652,2.741-9.25,3.312a30.133,30.133,0,0,0-5.139,2.056c-1.142.685-6.053,3.083-10.735,5.368-21.128,10.278-45.8,27.066-63.383,43.169-7.766,7.195-7.766,8.908,0,11.877,18.272,6.852,49.792,3.083,78.8-9.365,7.195-3.2,19.529-8.794,21.128-9.707.914-.571,5.824-3.083,10.849-5.71,5.025-2.512,10.735-5.71,12.562-6.852,1.941-1.256,4.454-2.741,5.71-3.426s3.883-2.17,5.71-3.426c1.941-1.256,4.226-2.627,5.139-3.083s4.911-2.969,8.908-5.71a66.828,66.828,0,0,1,7.766-4.911,18.644,18.644,0,0,0,3.883-2.512c5.025-3.655,4.454-6.624-2.17-10.963-3.2-1.941-6.281-3.655-6.966-3.655a13.693,13.693,0,0,1-4.34-1.6C794.089,664.254,777.872,663.226,767.48,664.368Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M294.68,668.365a38.175,38.175,0,0,1-4.226,1.028c-4.111.914-4.111,3.769-.228,9.479a67.389,67.389,0,0,1,4,6.624,57.735,57.735,0,0,0,3.312,5.71c1.256,1.827,2.741,4.454,3.426,5.71s2.17,3.769,3.426,5.71c1.256,1.827,2.741,4.454,3.426,5.71s2.056,3.655,3.2,5.368c1.028,1.713,4,6.281,6.4,10.278,11.192,17.93,28.893,38.258,41.8,48.194,7.88,6.053,19.072,11.306,28.094,13.133,9.022,1.941,12.334,1.37,12.791-1.941.571-3.54-3.54-17.13-8.337-28.208a138.552,138.552,0,0,0-12.22-23.183,31.843,31.843,0,0,1-3.2-5.482c0-.343-3.769-5.6-8.451-11.649C353.494,696,335.108,679.9,320.946,673.619c-7.537-3.312-22.841-6.4-26.267-5.253Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M590.465,670.078c-11.991,3.083-15.417,4.8-28.551,14.5-14.846,10.849-30.721,29.122-42.483,48.879-2.4,4-12.562,25.01-14.39,29.693-2.855,7.423-5.71,19.643-5.025,21.584.914,2.17,5.6,2.284,14.5.228,21.927-4.8,44.882-25.239,67.608-60.071,4.682-7.195,19.529-31.634,20.671-34.261a54.369,54.369,0,0,1,3.083-5.139c1.256-1.941,2.627-4.226,3.083-5.139a23.325,23.325,0,0,1,2.741-4.34c2.741-3.54,1.713-5.6-3.312-7.081-5.6-1.485-8.451-1.37-17.93,1.142Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M197.607,754.589c-3.769.571-10.392,1.6-14.846,2.17-26.5,3.883-46.481,16.331-53.9,33.461-.8,1.713-1.028,3.312-.571,3.54,1.6.914,21.813,4.226,37.344,6.053,22.841,2.855,73.775,2.855,87.365,0,21.813-4.454,38.144-11.42,47.737-20.442,6.4-6.167,7.195-8.108,3.769-9.821-4.682-2.627-24.668-7.994-39.514-10.849-21.356-4-54.589-6.053-67.38-4.111Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M673.262,754.018c-.914.228-7.88,1.028-15.417,1.713a241.27,241.27,0,0,0-35.974,5.939c-2.855.685-6.966,1.6-9.136,2.056-8.908,2.056-19.414,6.4-19.414,8.108,0,1.485,8.108,9.707,13.133,13.133,4.454,2.969,16.1,8.565,20.557,9.707,1.941.457,5.025,1.37,6.852,1.941a126.872,126.872,0,0,0,14.275,3.2c14.961,2.855,63.383,2.855,86.223,0,18.387-2.17,36.2-5.253,37.459-6.281,2.969-2.627-11.649-21.013-20.214-25.239-2.512-1.37-5.482-2.855-6.4-3.312-5.939-3.426-20.442-7.423-33.69-9.25C702.041,754.474,676.231,753.218,673.262,754.018Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M335.222,796.387c-13.933,2.4-26.152,5.025-31.406,6.852a28.546,28.546,0,0,1-6.51,1.6,18.25,18.25,0,0,0-5.71,1.6c-2.056.914-6.053,2.512-8.908,3.54-37,14.39-61.784,37.116-64.525,59.271-.685,4.911-.457,6.4.685,6.4,2.284,0,27.523-4.568,41.57-7.537a82.822,82.822,0,0,1,10.278-1.6c2.17,0,9.479-1.485,25.125-5.368q50.363-12.163,73.889-33c9.593-8.451,21.813-26.838,19.414-29.236C384.9,794.674,354.408,793.189,335.222,796.387Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M516.8,796.615c-3.426,1.142-6.281,2.512-6.281,3.083,0,.685,1.6,4.226,3.426,7.88,4.111,8.108,16.559,21.813,25.125,27.523,6.51,4.226,23.754,13.476,27.523,14.618,1.142.343,5.824,1.827,10.164,3.426,7.423,2.512,10.507,3.426,26.952,8.108a46.341,46.341,0,0,0,8.565,1.827,72.106,72.106,0,0,1,9.593,1.6c15.075,3.426,24.668,5.253,27.18,5.253a60.828,60.828,0,0,1,9.707,1.6c10.849,2.512,23.64,4.568,24.211,3.883.8-.8-2.17-13.019-4.226-17.473C672.463,844.009,656.132,828.478,639,819.8c-2.855-1.37-5.939-2.969-6.852-3.426a143.993,143.993,0,0,0-14.275-6.167c-2.512-.914-6.624-2.4-9.136-3.426-27.637-10.164-75.031-15.417-91.933-10.164Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M428.3,819.684c-3.769,1.941-9.25,4.911-12.22,6.624C398.262,836.7,384.1,853.6,382.959,865.936l-.343,3.426,6.966.343c9.022.457,18.158-3.655,25.81-11.42,6.167-6.281,11.306-16.217,20.442-39.514C437.091,815.459,436.405,815.573,428.3,819.684Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M465.413,820.484a148.39,148.39,0,0,0,5.6,14.961c.571,1.028,2.284,4.454,3.769,7.423,4.682,9.821,5.482,10.849,12.22,17.016,7.88,7.081,15.075,10.05,24.439,10.05h6.738l-.8-4.568a38.746,38.746,0,0,0-3.54-9.479c-1.485-2.627-3.2-5.824-3.769-7.081-2.512-5.71-19.072-18.958-33.461-26.723-10.507-5.71-12.562-5.939-11.192-1.6Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "fill": "none",
      "stroke": "#bea060",
      "stroke-miterlimit": "10"
    },
    attrs: {
      "cx": "448.147",
      "cy": "402.879",
      "r": "377.879"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("Zissel sucht den Bayron-Man 2010!")])]), _vm._v(" "), _c('div', {
    staticClass: "poster__body"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "gewinnspiel"
    }
  }, [_c('span', [_vm._v("zum Gewinnspiel")])])], 1)]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "hero--sm"
  }, [_c('h1', {
    staticClass: "hero-heading"
  }, [_vm._v("\n            Bayron-Man 2010\n            "), _c('small', [_vm._v("24. bis 26. September 2010")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--interlude"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col sm-8"
  }, [_c('h2', [_vm._v("Der Durstlöscher für Sportler")]), _vm._v(" "), _c('p', [_vm._v("Für Sportler hat Bier einen entscheidenden Vorteil:"), _c('br'), _vm._v("\n                        Mit seinem hohen Wassergehalt und der relativ niedrigen Alkoholkonzentration\n                        ersetzt das Bier quasi als "), _c('b', [_vm._v("isotonischer Durstlöscher")]), _vm._v(" schnell die verlorene\n                        Flüssigkeit. Die leicht verfügbaren Kohlenhydrate machen den Energieverlust\n                        durch den Sport wieder wett. Besonders eignet sich hierfür "), _c('b', [_vm._v("alkoholfreies\n                        Bier oder Leichtbier.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("3 Kilometer Schwimmen auf dem Main,")]), _vm._v(" "), _c('li', [_vm._v("90 Kilometer auf dem Rad und")]), _vm._v(" "), _c('li', [_vm._v("21 Kilometer Laufen durch das Frankenland")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("heißt am"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "em"
  }, [_vm._v("Sonntag, 26. September 2010")]), _c('br'), _vm._v("\n                die sportliche Herausforderung.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Und für alle, die lieber feiern oder die mehr als 1000 Läufer anfeuern wollen,\n                organisiert Zissel ein ganzes Wochenende mit Partyspaß, Events und Live-Musik.\n                Zissel ist immer dabei!"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v("Gewinnen Sie mit Zisselbier.")])])
}]}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--light featured"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "products-featured"
  }, [_c('h2', [_vm._v("Ideal für jede Party!\n                "), _c('span', [_vm._v("Zissel ist Partykult!")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-box"
  }, [_c('div', {
    staticClass: "featured-item"
  }, [_c('div', {
    staticClass: "featured-item__bottle"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/grapefruit-bottle.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "featured-item__fruit",
    attrs: {
      "src": "assets/img/grapefruit-fruit.png",
      "alt": "Grapefruit"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Zissel Grapefruit")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-item"
  }, [_c('div', {
    staticClass: "featured-item__bottle"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/lemon-bottle.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "featured-item__fruit",
    attrs: {
      "src": "assets/img/lemon-fruit.png",
      "alt": "Grapefruit"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Zissel Lemon")])]), _vm._v(" "), _c('div', {
    staticClass: "featured-item"
  }, [_c('div', {
    staticClass: "featured-item__bottle"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/cactus-bottle.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "featured-item__fruit",
    attrs: {
      "src": "assets/img/cactus-fruit.png",
      "alt": "Grapefruit"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Zissel Kaktusfeige")])])]), _vm._v(" "), _c('div', {
    staticClass: "featured-description"
  }, [_c('span', {
    staticClass: "description-sticker"
  }, [_vm._v("Neu!")]), _vm._v(" "), _c('p', [_vm._v("\n                    Prickelnd leicht, fruchtig frisch und exotisch herb sind\n                    unsere Hefemixgetränke mit "), _c('b', [_vm._v("Grapefruit-, Lemon- oder Kaktusfeigensaft.")]), _vm._v("\n                    Genießt den unverwechselbaren Mix!\n                ")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "txt-sm"
  }, [_vm._v("Biermischgetränk aus 50 % Hefeweizen und 50 % Fruchtsaft, Alkoholgehalt vol % 2,5")])])])])])
}]}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "modal"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('transition', {
    attrs: {
      "name": "push",
      "mode": "out-in"
    }
  }, [(!_vm.underAge) ? _c('div', {
    key: "buttons",
    staticClass: "modal-content--btn"
  }, [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": '/' + _vm.destination
    }
  }, [_c('span', [_vm._v("Ja, ich bin mindestens 16 Jahre alt.")])]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.underAge = !_vm.underAge
      }
    }
  }, [_c('span', [_vm._v("Nein, leider noch nicht.")])])], 1) : _vm._e(), _vm._v(" "), (_vm.underAge) ? _c('div', {
    key: "deny",
    staticClass: "modal-deny"
  }, [_c('p', [_vm._v("Der Internetauftritt steht leider nur Personen zu Verfügung,\n                            die mindestens 16 Jahre alt sind.")])]) : _vm._e()])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "modal-header"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/logo.svg",
      "alt": "Privatbrauerei Zissel"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Ihre Privatbrauerei Zissel setzt sich im Rahmen der gesetzlichen\n            Bestimmungen für den verantwortungsbewussten Umgang mit alkoholischen\n            Getränken ein. Auf den folgenden Seiten finden Sie Information\n            über alkoholische Getränke.")]), _vm._v(" "), _c('p', [_vm._v("Wir bitten Sie daher zu bestätigen, dass Sie über 16 Jahre alt sind!")])])
}]}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap page-biere"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('featured-products'), _vm._v(" "), _c('section', {
    staticClass: "section--dark"
  }, [_c('ul', {
    staticClass: "product-list"
  }, [_c('li', {
    staticClass: "product-list__item"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "64",
      "height": "64",
      "viewBox": "0 0 64 64"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "#FFF",
      "stroke-width": "2",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 33c-1.167 3.667-.292 7.792 2 10 4.997-1.376 6.895-4.023 9-8"
    }
  }), _c('path', {
    attrs: {
      "d": "M21 42c-.625 4.458 2.031 6.937 4 9 2.048-.564 2.906-1.875 4-4M32 36.082c2.542-.499 7-3.249 7-7.082 4.3 4.166 7.417 4.041 11 4.082C50 22.125 41.941 15 32 15s-18 7.125-18 18.082c3.583-.041 6.7.084 11-4.082 0 3.833 4.458 6.583 7 7.082z"
    }
  }), _c('path', {
    attrs: {
      "d": "M47 33c1.167 3.667.292 7.792-2 10-4.997-1.376-6.895-4.023-9-8"
    }
  }), _c('path', {
    attrs: {
      "d": "M39 40c0 4.331-3.1 7.875-7 9-3.9-1.125-7-4.669-7-9"
    }
  }), _c('path', {
    attrs: {
      "d": "M43 42c.625 4.458-2.031 6.937-4 9-2.048-.564-2.906-1.875-4-4"
    }
  }), _c('path', {
    attrs: {
      "d": "M37 49.9648c-.937 3.16-2.781 5.254-5 6.035-2.219-.781-4.063-2.875-5-6.035M32 9v6"
    }
  })])]), _vm._v(" "), _c('h2', [_vm._v("Zissel Hell")]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('li', {
    staticClass: "product-list__item"
  }, [_c('svg', {
    staticClass: "svg replaced-svg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "64",
      "height": "64",
      "viewBox": "0 0 64 64"
    }
  }, [_c('title', [_vm._v("BottleCrate")]), _c('g', {
    attrs: {
      "stroke": "#FFF",
      "stroke-width": "2",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M9 44V34h46v10H9zm46 0v10H9V44h46zM11 44h42M12 39h2M50 39h2M12 49h2M50 49h2M27 34v-2c0-3.594-4-5.126-4-7 0-3.417-1-9.756-1-10 0-.617 1-.833 1-2 0-.466-1-.792-1-1v-1c0-.64-1-1-3-1s-3 .36-3 1v1c-.438.208-1 .534-1 1 0 1.167 1 1.383 1 2 0 .244-1 6.583-1 10 0 1.874-4 3.406-4 7v2M40 34v-2c0-3.594-4-5.126-4-7 0-3.417-1-9.756-1-10 0-.617 1-.833 1-2 0-.466-1-.792-1-1v-1c0-.64-1-1-3-1s-3 .36-3 1v1c-.438.208-1 .534-1 1 0 1.167 1 1.383 1 2 0 .244-1 6.583-1 10 0 .611-.426 1.292-1 2.058M53 34v-2c0-3.594-4-5.126-4-7 0-3.417-1-9.756-1-10 0-.617 1-.833 1-2 0-.466-1-.792-1-1v-1c0-.64-1-1-3-1s-3 .36-3 1v1c-.438.208-1 .534-1 1 0 1.167 1 1.383 1 2 0 .244-1 6.583-1 10 0 .611-.426 1.292-.999 2.058"
    }
  })])]), _vm._v(" "), _c('h2', [_vm._v("Zissel Dunkel")]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('li', {
    staticClass: "product-list__item"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "54",
      "height": "54",
      "viewBox": "0 0 57.234 57.234"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M57.23 49.927c-.001-.037.001-.075-.001-.112-.018-.316-.067-.627-.138-.932-.011-.049-.02-.099-.033-.148-.081-.309-.19-.609-.322-.898-.011-.023-.015-.048-.025-.071-.012-.024-.029-.044-.041-.069-.137-.28-.297-.549-.48-.803-.036-.05-.076-.097-.114-.146-.181-.234-.379-.457-.598-.66-.043-.04-.09-.077-.134-.115-.229-.2-.473-.385-.737-.547-.034-.021-.071-.038-.106-.058-.273-.159-.562-.298-.869-.41-.014-.005-.026-.014-.04-.019-.008-.003-.016-.004-.024-.006l-14.225-5.094c3.458-3.585 5.653-8.933 5.653-15.22 0-11.562-3-16-3-16 0 9.5-8 16-8 16 0-7.5-3-14-3-14 0 5.875-4 9-4 9-5.344-5.344 0-18 0-18-7.61 1.004-14.425 6.25-14.425 15 0 6.188 1.728 10.304 4.425 13 0 0-2.393-1.388-4.78-2.304.632 5.003 2.721 9.4 5.705 12.513L3.666 44.931c-.008.003-.016.004-.024.006-.014.005-.026.014-.04.019-.307.112-.595.251-.869.41-.035.02-.071.038-.106.058-.264.162-.508.347-.737.547-.045.039-.091.075-.134.115-.219.204-.416.426-.598.66-.038.049-.077.096-.114.146-.183.254-.343.523-.48.803-.012.024-.029.044-.041.069-.011.023-.015.048-.025.071-.132.289-.241.59-.322.898-.013.049-.022.098-.033.148-.071.305-.12.616-.138.932-.002.037 0 .075-.001.112-.012.324.001.65.049.977.002.015.006.029.008.044.052.343.136.686.257 1.025.263.734.682 1.377 1.199 1.919 1.019 1.072 2.442 1.727 3.98 1.727h.011c.629 0 1.249-.108 1.844-.321l21.266-7.616 21.267 7.616c.594.213 1.214.321 1.843.321h.01c1.524 0 2.937-.643 3.954-1.698.529-.548.957-1.201 1.224-1.946.121-.339.205-.682.257-1.025.002-.015.006-.029.008-.044.047-.327.06-.654.049-.977zm-2.029.69c-.026.177-.077.353-.131.529-.015.05-.02.101-.038.15-.158.44-.406.828-.708 1.161-.652.716-1.583 1.158-2.592 1.159-.399-.001-.794-.07-1.175-.206-.88-.315-1.585-.955-1.984-1.8s-.446-1.795-.13-2.676c.497-1.388 1.821-2.321 3.295-2.321.392 0 .78.068 1.154.199l.026.009c1.345.482 2.21 1.708 2.306 3.049.001.018.007.036.008.053.01.172-.006.346-.022.52-.006.06 0 .117-.009.174zM19.906 31.849c0-3.616 2.111-5.828 5.944-6.227.336-.031.671.104.884.37.212.265.276.621.167.943-.414 1.235-.769 3.23-.428 4.206.625-.098 1.574-.359 1.574-1.036 0-.463.317-.865.768-.973.453-.106.916.108 1.125.521.042.084.786 1.569 1.185 3.462.854-1.046 1.783-2.535 1.783-4.056 0-.418.261-.793.653-.938.392-.147.833-.031 1.106.288.161.187 1.566 1.952 1.566 6.232 0 4.382-3.499 7.825-8.012 7.963-1.009-.022-2.005-.167-2.978-.431-2.835-.952-4.99-3.366-5.481-6.433-.055-.34.07-.685.33-.912.088-.077.187-.136.292-.177-.318-.827-.478-1.762-.478-2.802zM5.496 46.614c1.474 0 2.798.933 3.295 2.321.651 1.817-.298 3.825-2.115 4.476-.381.136-.776.205-1.175.206-1.01-.002-1.942-.443-2.594-1.161-.302-.333-.549-.72-.707-1.16-.018-.049-.022-.1-.038-.15-.054-.176-.106-.352-.131-.529-.008-.057-.003-.114-.009-.171-.016-.174-.032-.348-.022-.52.001-.018.007-.036.008-.053.097-1.341.961-2.567 2.306-3.049l.026-.009c.377-.132.764-.201 1.156-.201zm5.17 5.37c.159-.439.258-.901.301-1.371.009 0 .018.004.028.004.104 0 .211-.017.316-.052l6-2c.524-.175.807-.741.632-1.265-.175-.523-.74-.808-1.265-.632l-5.892 1.964c-.035-.124-.068-.248-.112-.371-.089-.247-.199-.482-.319-.71l2.956-.985c.524-.175.807-.741.632-1.265-.174-.524-.739-.809-1.265-.632l-3 1c-.212.071-.371.216-.49.387-.275-.25-.578-.466-.898-.655l11.057-3.96c2.294 1.735 4.857 2.773 7.529 3.075.05.006.099.013.148.019.487.05.976.083 1.469.083.502 0 .999-.035 1.494-.086.162-.017.322-.04.482-.062.337-.047.671-.106 1.003-.176.173-.036.347-.069.518-.112.442-.111.88-.238 1.312-.39.161-.057.317-.128.476-.19.305-.119.608-.245.907-.385.161-.076.32-.156.478-.237.377-.192.748-.401 1.114-.626.035-.022.071-.041.106-.063.45-.282.895-.579 1.327-.911l11.229 4.021c-.377.224-.733.482-1.047.789-.113-.237-.315-.431-.583-.52l-3-1c-.525-.176-1.09.108-1.265.632s.108 1.09.632 1.265l3 1c.06.02.12.021.18.029-.111.215-.216.434-.299.666-.056.158-.079.32-.121.48-.044-.022-.079-.057-.127-.073l-6-2c-.526-.175-1.091.109-1.265.632-.175.524.108 1.09.632 1.265l6 2c.105.035.212.052.316.052.094 0 .185-.018.274-.043.041.483.157.957.327 1.42l-17.979-6.439-17.948 6.428z"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("Zissel Rauch")]), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', {
    staticClass: "product-list__item"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "50",
      "height": "60",
      "viewBox": "-80 0 820 800",
      "stroke": "transparent"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFF",
      "stroke": "#FFF",
      "stroke-width": "60px",
      "d": "M6 6v419a319 319 0 0 0 638 0V6"
    }
  }), _c('path', {
    staticStyle: {
      "transform": "translateY(10px)"
    },
    attrs: {
      "fill": "#1b1c1e",
      "d": "M11 11v464l114-246 100 246 100-246 100 246 100-246 114 246V11"
    }
  })]), _vm._v(" "), _c('h2', [_vm._v("Zissel Urtrüb")]), _vm._v(" "), _vm._m(5)])])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "hero--sm"
  }, [_c('h1', {
    staticClass: "hero-heading"
  }, [_vm._v("\n            Zissel"), _c('br'), _vm._v(" "), _c('small', [_vm._v("zischt fränkisch!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--interlude"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col sm-8"
  }, [_c('h2', [_vm._v("Unsere Zissel-Biere")]), _vm._v(" "), _c('p', [_vm._v("\n                        brauen wir nach altem Rezept\n                        mit heimischen Rohstoffen aus bester Qualität.\n                    ")]), _vm._v(" "), _c('p', [_vm._v("\n                        Ob frisch gezapft aus dem Fass oder aus unseren"), _c('br'), _vm._v("\n                        unverwechselbaren Bügelflaschen – "), _c('b', [_vm._v("ein Zissel ist immer ein Genuss.")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Spritzig herb – unser Helles wird mit Hopfen aus"), _c('br'), _vm._v("\n                    der Hallertau gebraut. Er verleiht unserem Bier die"), _c('br'), _vm._v("\n                    unvergleichliche Würze sowie seinen spritzig herben Charakter. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Unser Dunkles ist ein untergäriges Vollbier, typisch"), _c('br'), _vm._v("\n                    fränkisch und würzig im Geschmack.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Das Malz zur Herstellung unseres Rauchbieres wird über"), _c('br'), _vm._v("\n                    Buchenholzfeuer geröstet und gibt den rauchigen Geschmack"), _c('br'), _vm._v("\n                    an das Bier weiter. ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Unser „Ungespundetes“ ist ein nach fränkischer"), _c('br'), _vm._v("\n                    Tradition gebrautes Bier – naturbelassen, hefetrüb"), _c('br'), _vm._v("\n                    und unfiltriert.")])
}]}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap page-bierkul-tour"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "hero--sm"
  }, [_c('h1', {
    staticClass: "hero-heading"
  }, [_c('small', [_vm._v("Ein Fest ist ein Fest.")]), _vm._v("\n            Oder ein Zissel!\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--interlude"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col sm-8"
  }, [_c('h2', [_vm._v("Die Brauereibesichtigungen bei Zissel")]), _vm._v(" "), _c('p', [_vm._v("erfreuen sich in den letzten Jahren immer größerer Beliebtheit.")]), _vm._v(" "), _c('p', [_vm._v("Immer freitags und samstags können Sie hinter"), _c('br'), _vm._v("\n                        die Kulissen der Zissel-Braukunst blicken.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--light"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col sm-6"
  }, [_c('p', [_vm._v("\n                        Wir laden Sie ein, in unserer Privatbrauerei die Herstellung unserer Biere kennenzulernen.\n                        Dabei werden Sie sowohl mit unseren Rohstoffen als auch mit dem modernen Stand der\n                        Brautechnik vertraut gemacht. Selbstverständlich können Sie während des Rundgangs unsere\n                        verschiedenen Biere verkosten. Ein bieriges Erlebnis erwartet Sie!\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "infobox"
  }, [_c('h3', [_vm._v("Führungen nach telefonischer Anmeldung:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("freitags 16.00 Uhr ")]), _vm._v(" "), _c('li', [_vm._v("samstags 16.00 Uhr")]), _vm._v(" "), _c('li', [_vm._v("Kosten für Führung inklusive Bier und Brauervesper: 15 Euro pro Teilnehmer.")]), _vm._v(" "), _c('li', [_vm._v("Führungen mit unserem Braumeister und spezielle Arrangements sind ebenfalls möglich.")])]), _vm._v(" "), _c('p', [_vm._v("\n                            Buchungen "), _c('a', {
    attrs: {
      "href": "mailto:#0"
    }
  }, [_vm._v("hier per E-Mail")]), _vm._v(" oder bei"), _c('br'), _vm._v(" "), _c('b', [_vm._v("Peter Gröger, Telefon (0 92 14) 13 24 53")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col sm-6"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/einkehren-slider-2.jpg",
      "alt": "Brauereiführung"
    }
  })])])])])
}]}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrap page-kultur-genuss"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "hero--sm"
  }, [_c('h1', {
    staticClass: "hero-heading"
  }, [_c('small', [_vm._v("Kultur & Genuss")]), _vm._v("\n            in Kulmbach!\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section--light"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col sm-6"
  }, [_c('h2', [_vm._v("Eine runde Sache für „Bierologen“!")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ankunft am Bahnhof Kulmbach")]), _vm._v(" "), _c('li', [_vm._v("Spaziergang zum Kulmbacher Mönchshof (Dauer 15 Min.)")]), _vm._v(" "), _c('li', [_vm._v("Besuch des Bayerischen Brauereimuseums (Dauer 90 Min.)")]), _vm._v(" "), _c('li', [_vm._v("Einkehr bei Zissel mit Bierprobe, Zapferprüfung und Biermenü (Open end)")]), _vm._v(" "), _c('li', [_vm._v("Der Zissel-Wirt führt Sie humorvoll durch die Bierprobe.\n                            Sie erfahren einiges über Bier und seine Herstellung.")])]), _vm._v(" "), _c('div', {
    staticClass: "infobox"
  }, [_c('h3', [_vm._v("Sie trinken:")]), _vm._v(" "), _c('p', [_vm._v("\n                            Das stärkste Bier der Welt sowie Zissel Hell, Zissel Dunkel,\n                            Zissel Rauch und unsere neuen Mixgetränke. Das Bier-Probier-Glas dürfen Sie mitnehmen.\n                            Dazu empfehlen wir unser Original Kulmbacher Bierfleisch.\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col sm-6"
  }, [_c('img', {
    attrs: {
      "src": "assets/img/kultur-genuss-content.jpg",
      "alt": "Brauereiführung"
    }
  })])])])])
}]}

/***/ }),
/* 35 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "modal game"
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_c('svg', {
    staticClass: "logo-animated",
    attrs: {
      "id": "logo-animated",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 894.294 870.151"
    }
  }, [_c('path', {
    staticClass: "bottle",
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M490.141,559.871c.042-10.789,2.054-25.236,5.13-37.571,1.489-5.966,36.551-146.926,36.551-207.754,0-61.147-12.013-97.891-12.52-99.425a8.19,8.19,0,0,0-7.778-5.612H390.477a8.2,8.2,0,0,0-8.039,6.59c-.5,2.5-12.26,61.743-12.26,98.442,0,60.828,35.066,201.788,36.56,207.759,5.186,20.779,7.343,47.546,2.158,52.736-14.1,14.1-14.5,28.414-14.5,30a8.2,8.2,0,0,0,8.2,8.2h96.832a8.186,8.186,0,0,0,8.2-8.2c0-1.588-.426-15.907-14.512-30Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M68.672,178.092c-.228.8-1.37,5.368-2.4,10.05s-2.512,11.078-3.426,14.275c-9.022,33.918-10.164,59.271-3.312,77.315C64.675,293.666,67.53,298.8,69.7,298.8c2.741.114,13.933-18.044,18.5-30.15,7.309-18.843,7.652-20.557,7.652-38.372.114-17.93-.114-18.729-7.652-33.918a53.656,53.656,0,0,0-10.164-13.476c-6.51-6.281-8.679-7.309-9.365-4.8Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M823.782,181.519c-8.679,8.223-13.248,15.075-17.016,26.267-3.312,9.593-3.54,34.375-.457,44.882,5.824,19.986,20.1,46.709,24.439,45.91,1.6-.228,6.167-8.223,9.136-15.646,2.512-6.51,5.824-24.554,5.824-31.977,0-8.794-3.312-28.208-8.565-49.107-.8-3.426-2.512-10.392-3.655-15.3-1.256-5.025-2.627-9.25-3.312-9.479-.571-.228-3.426,1.827-6.4,4.454Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M13.855,262.032c-1.142,1.142-.8,14.275.457,21.013.685,3.426,1.713,10.278,2.284,15.3,2.512,22.955,9.136,46.709,17.587,63.383,6.51,13.019,21.47,28.437,27.751,28.551,2.17,0,2.512-.8,3.312-7.766,1.827-17.587-.8-46.823-6.053-65.324-6.966-25.01-20.1-44.882-33.69-51.163C17.4,262.374,14.54,261.346,13.855,262.032Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M881.111,263.059c-9.936,3.2-20.9,12.9-27.751,24.325-13.476,22.726-21.013,60.413-18.5,92.619.914,11.649,1.941,12.562,8.908,7.766,16.445-11.42,26.609-29.236,34.261-59.728,3.2-12.448,5.368-23.983,5.368-27.409a100.66,100.66,0,0,1,1.713-12.334,115.987,115.987,0,0,0,1.713-17.473c0-8.908-.457-9.479-5.71-7.766Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M118.807,317.991C103.733,336.949,89.8,363.9,83.633,385.713c-4.8,16.674-5.368,20.442-5.368,35.517,0,19.529,2.17,26.838,11.306,38.6,3.654,4.682,4,4.8,5.482,2.855,1.6-2.17,19.757-38.943,22.955-46.138.914-2.17,2.4-5.482,3.2-7.195a14.555,14.555,0,0,0,1.6-5.025,12.553,12.553,0,0,1,1.6-4.682c1.713-3.312,4-10.621,6.738-21.356,4.454-17.359,5.368-33.347,2.627-46.252-1.6-7.994-6.966-20.557-8.794-20.557C124.4,311.481,121.662,314.451,118.807,317.991Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M772.961,314.565c-4.454,6.738-8.337,22.612-8.337,33.461.114,10.963,4.111,32.662,7.537,40.885a18.508,18.508,0,0,1,1.6,5.368,18.507,18.507,0,0,0,1.6,5.368c.914,2.056,2.741,6.624,4.111,10.05,6.852,17.13,25.125,53.675,26.838,53.675,3.083,0,10.164-10.621,13.59-20.328,1.713-4.8,2.17-9.479,2.056-21.47,0-16.217-1.37-24.1-6.738-39.857-1.6-4.454-3.2-9.593-3.769-11.42-4.111-13.362-31.748-58.814-35.86-58.814-.343,0-1.6,1.37-2.627,3.083Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M3.577,350.082c-1.37,1.256-.685,23.64,1.142,35.517,2.17,15.3,4.8,28.893,6.852,35.517,2.969,9.936,6.167,19.529,7.195,21.47,5.139,10.164,6.852,13.248,11.078,19.757,5.139,7.766,22.5,25.353,27.066,27.294,1.37.685,4.682,2.512,7.423,4.111,7.081,4.111,8.451,3.2,7.537-4.911-1.941-19.643-9.821-54.246-16.1-70.577-.914-2.512-2.512-6.624-3.54-9.136A127.06,127.06,0,0,0,44.8,393.136c-7.994-13.248-12.677-19.529-19.529-26.723-7.994-8.223-20.442-17.7-21.7-16.331Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M887.964,355.107c-10.164,7.652-15.075,12.562-22.27,22.155-14.39,18.958-25.01,45.567-31.863,79.257-2.512,12.334-5.025,27.066-5.71,33.461-.8,7.195.685,7.652,9.25,2.969,13.7-7.537,27.523-21.128,36.545-35.86,2.4-3.883,9.479-18.843,9.479-19.986a20.172,20.172,0,0,1,1.6-4.8c3.54-8.223,7.309-24.668,10.392-45.11,1.827-12.106,2.4-36.431.914-37.23-.571-.343-4.226,2.056-8.337,5.139Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M124.517,439.845a22.706,22.706,0,0,0-1.713,7.081,58.818,58.818,0,0,1-1.941,10.05c-2.855,10.735-2.855,61.784,0,73.775,5.025,20.442,7.423,27.18,14.5,42.255,6.852,14.618,21.356,36.545,24.1,36.545,2.512,0,5.71-9.022,7.88-22.27a79.217,79.217,0,0,1,2.4-10.849c2.284-8.223,1.941-52.191-.571-61.67-5.824-22.27-11.649-37.116-18.958-48.536a57.731,57.731,0,0,1-3.312-5.71c-1.827-3.769-17.7-23.754-19.3-24.325-.8-.228-2.17,1.37-3.083,3.655Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M764.853,444.756c-6.852,8.565-16.445,23.183-18.615,28.208a45.882,45.882,0,0,1-2.056,4.111c-4.111,6.966-9.593,22.955-13.362,38.715-2.4,10.278-2.741,51.049-.457,59.5.8,2.855,1.827,7.994,2.4,11.42,1.6,10.507,4.911,20.785,6.966,22.155,1.6.914,2.4.685,3.769-1.028,2.17-2.855,12.105-17.587,13.819-20.557,3.083-5.253,13.019-25.581,13.019-26.723a19.032,19.032,0,0,1,1.6-4.911C780.27,536,783.925,504.6,781.3,475.363c-.914-10.05-2.284-20.1-2.855-22.27a29.724,29.724,0,0,1-1.256-7.423c0-3.769-2.17-8.679-4.111-9.365-.685-.228-4.454,3.54-8.223,8.451Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M3.577,480.273c-1.028,1.6,3.883,16.9,8.794,27.637,8.108,17.93,25.581,35.4,48.422,48.536,4.911,2.855,9.707,5.71,10.621,6.281,7.309,4.34,45.224,22.841,46.937,22.841,1.941,0,2.17-.571,1.6-4.34-1.256-7.423-4.111-15.76-9.365-27.066-8.451-18.387-26.5-36.088-52.3-51.62C52.341,499,31.442,489.181,21.164,485.07a95.449,95.449,0,0,1-9.479-4.111C8.031,479.131,4.49,478.9,3.577,480.273Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M887.964,481.3c-2.17,1.028-5.71,2.512-7.652,3.312-8.451,3.54-11.991,5.025-15.532,6.51-5.482,2.4-19.3,9.479-23.754,12.106-2.17,1.37-4.682,2.741-5.6,3.2-1.6.685-5.253,3.312-15.417,10.849-6.281,4.8-19.986,19.3-23.983,25.467-4.454,7.081-11.991,22.726-11.991,25.01a23.273,23.273,0,0,1-1.713,5.6c-2.284,5.368-2.284,12.22-.114,12.22,1.37,0,43.283-20.785,53.219-26.381,20.9-11.877,39.514-28.551,48.765-43.854,5.71-9.365,13.819-32.434,12.334-34.832-1.028-1.6-3.883-1.256-8.565.8Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M29.843,569.466c-.685,1.028.343,4.8,1.485,5.824.343.343,1.941,2.4,3.54,4.568,13.933,19.986,41,45.567,59.957,56.645,3.083,1.827,6.738,3.883,7.994,4.682a49.611,49.611,0,0,0,4.911,2.627c1.485.571,5.253,2.284,8.565,3.769,16.674,7.652,32.548,11.763,54.475,14.5,12.334,1.485,12.562,1.485,12.562-.571,0-2.284-11.877-20.328-19.986-30.264-9.022-10.963-33.119-32.89-39.4-35.745-.914-.457-3.2-1.827-5.139-3.083-4.911-3.083-16.674-9.25-19.986-10.278-1.6-.571-5.6-2.056-9.022-3.312-9.365-3.54-23.3-6.624-36.659-8.108C31.785,568.438,30.528,568.324,29.843,569.466Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M861.7,569.123c-32.548,2.969-47.623,6.738-69.093,17.245-16.331,8.108-27.066,15.646-40.77,29.236-16.217,15.874-37.459,44.539-34.946,47.166.914.8,21.013-1.485,31.177-3.655,17.93-3.769,28.322-7.423,45.11-15.874,7.537-3.769,23.526-13.59,25.125-15.417.343-.343,2.855-2.4,5.71-4.568,12.105-9.136,27.409-25.01,38.715-39.971,8.794-11.763,9.593-13.362,7.423-14.161a8.064,8.064,0,0,0-3.083-.457c-.8,0-3.2.343-5.368.457Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M185.159,573.805c-2.17,2.284,2.627,31.177,7.423,45.453a68.312,68.312,0,0,1,2.17,6.852c2.056,7.195,8.451,22.955,11.42,27.98.571.914,2.284,4.111,3.883,7.081,3.654,6.738,10.392,17.245,12.334,19.3.8.914,3.769,4.454,6.624,7.88a180.224,180.224,0,0,0,38.943,34.6c6.738,4.454,8.908,5.139,9.136,2.741,1.37-15.76-4.8-48.422-12.791-67.608A251.067,251.067,0,0,0,253,635.247c-1.256-1.941-2.627-4.226-3.083-5.139C248.085,626,238.149,614,229.7,605.44c-8.451-8.451-26.838-23.3-28.779-23.3a5.658,5.658,0,0,1-2.627-1.6c-3.083-2.627-12.448-7.423-13.133-6.738Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M710.378,575.4c-1.827,1.142-4.226,2.512-5.139,2.969s-4,2.284-6.852,4.226c-18.729,12.448-37.687,30.949-47.508,46.366-9.136,14.5-18.272,34.832-21.013,46.823-.457,2.17-1.37,6.281-2.056,9.136-3.312,13.476-4.8,23.754-4.8,32.434,0,5.139.343,9.707.685,10.164,1.713,1.713,25.467-16.1,37.573-28.322,17.016-17.016,27.751-33.233,38.715-58.243,9.136-20.785,18.5-63.383,14.846-66.809C714.261,573.691,712.32,574.262,710.378,575.4Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M110.813,664.482c-7.423.914-14.732,3.312-16.788,5.368a4.524,4.524,0,0,1-2.627,1.37c-1.827,0-6.281,4.911-6.281,7.081,0,1.37,17.016,13.59,23.983,17.245a54.372,54.372,0,0,1,5.139,3.083c1.941,1.256,4.454,2.741,5.71,3.426s5.368,2.969,9.136,5.139c8.223,4.8,34.489,17.7,41.684,20.557,2.855,1.142,6.738,2.627,8.565,3.426a96.756,96.756,0,0,0,9.707,3.2c3.426,1.028,9.365,2.627,13.133,3.769,10.164,2.855,37,2.969,43.968,0,7.766-3.2,8.565-3.655,8.908-5.6.457-2.284-14.39-15.417-32.662-28.665-3.883-2.855-7.309-5.253-7.537-5.253a59.611,59.611,0,0,1-7.195-4.34c-7.081-4.8-8.108-5.368-21.7-11.991-15.3-7.652-28.437-12.9-34.6-14.161-1.6-.343-5.139-1.256-7.994-2.056-6.51-1.941-23.64-2.741-32.548-1.6Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M767.48,664.368a112.665,112.665,0,0,0-27.98,6.966c-3.426,1.256-7.652,2.741-9.25,3.312a30.133,30.133,0,0,0-5.139,2.056c-1.142.685-6.053,3.083-10.735,5.368-21.128,10.278-45.8,27.066-63.383,43.169-7.766,7.195-7.766,8.908,0,11.877,18.272,6.852,49.792,3.083,78.8-9.365,7.195-3.2,19.529-8.794,21.128-9.707.914-.571,5.824-3.083,10.849-5.71,5.025-2.512,10.735-5.71,12.562-6.852,1.941-1.256,4.454-2.741,5.71-3.426s3.883-2.17,5.71-3.426c1.941-1.256,4.226-2.627,5.139-3.083s4.911-2.969,8.908-5.71a66.828,66.828,0,0,1,7.766-4.911,18.644,18.644,0,0,0,3.883-2.512c5.025-3.655,4.454-6.624-2.17-10.963-3.2-1.941-6.281-3.655-6.966-3.655a13.693,13.693,0,0,1-4.34-1.6C794.089,664.254,777.872,663.226,767.48,664.368Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M294.68,668.365a38.175,38.175,0,0,1-4.226,1.028c-4.111.914-4.111,3.769-.228,9.479a67.389,67.389,0,0,1,4,6.624,57.735,57.735,0,0,0,3.312,5.71c1.256,1.827,2.741,4.454,3.426,5.71s2.17,3.769,3.426,5.71c1.256,1.827,2.741,4.454,3.426,5.71s2.056,3.655,3.2,5.368c1.028,1.713,4,6.281,6.4,10.278,11.192,17.93,28.893,38.258,41.8,48.194,7.88,6.053,19.072,11.306,28.094,13.133,9.022,1.941,12.334,1.37,12.791-1.941.571-3.54-3.54-17.13-8.337-28.208a138.552,138.552,0,0,0-12.22-23.183,31.843,31.843,0,0,1-3.2-5.482c0-.343-3.769-5.6-8.451-11.649C353.494,696,335.108,679.9,320.946,673.619c-7.537-3.312-22.841-6.4-26.267-5.253Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "d": "M590.465,670.078c-11.991,3.083-15.417,4.8-28.551,14.5-14.846,10.849-30.721,29.122-42.483,48.879-2.4,4-12.562,25.01-14.39,29.693-2.855,7.423-5.71,19.643-5.025,21.584.914,2.17,5.6,2.284,14.5.228,21.927-4.8,44.882-25.239,67.608-60.071,4.682-7.195,19.529-31.634,20.671-34.261a54.369,54.369,0,0,1,3.083-5.139c1.256-1.941,2.627-4.226,3.083-5.139a23.325,23.325,0,0,1,2.741-4.34c2.741-3.54,1.713-5.6-3.312-7.081-5.6-1.485-8.451-1.37-17.93,1.142Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M197.607,754.589c-3.769.571-10.392,1.6-14.846,2.17-26.5,3.883-46.481,16.331-53.9,33.461-.8,1.713-1.028,3.312-.571,3.54,1.6.914,21.813,4.226,37.344,6.053,22.841,2.855,73.775,2.855,87.365,0,21.813-4.454,38.144-11.42,47.737-20.442,6.4-6.167,7.195-8.108,3.769-9.821-4.682-2.627-24.668-7.994-39.514-10.849-21.356-4-54.589-6.053-67.38-4.111Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M673.262,754.018c-.914.228-7.88,1.028-15.417,1.713a241.27,241.27,0,0,0-35.974,5.939c-2.855.685-6.966,1.6-9.136,2.056-8.908,2.056-19.414,6.4-19.414,8.108,0,1.485,8.108,9.707,13.133,13.133,4.454,2.969,16.1,8.565,20.557,9.707,1.941.457,5.025,1.37,6.852,1.941a126.872,126.872,0,0,0,14.275,3.2c14.961,2.855,63.383,2.855,86.223,0,18.387-2.17,36.2-5.253,37.459-6.281,2.969-2.627-11.649-21.013-20.214-25.239-2.512-1.37-5.482-2.855-6.4-3.312-5.939-3.426-20.442-7.423-33.69-9.25C702.041,754.474,676.231,753.218,673.262,754.018Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M335.222,796.387c-13.933,2.4-26.152,5.025-31.406,6.852a28.546,28.546,0,0,1-6.51,1.6,18.25,18.25,0,0,0-5.71,1.6c-2.056.914-6.053,2.512-8.908,3.54-37,14.39-61.784,37.116-64.525,59.271-.685,4.911-.457,6.4.685,6.4,2.284,0,27.523-4.568,41.57-7.537a82.822,82.822,0,0,1,10.278-1.6c2.17,0,9.479-1.485,25.125-5.368q50.363-12.163,73.889-33c9.593-8.451,21.813-26.838,19.414-29.236C384.9,794.674,354.408,793.189,335.222,796.387Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M516.8,796.615c-3.426,1.142-6.281,2.512-6.281,3.083,0,.685,1.6,4.226,3.426,7.88,4.111,8.108,16.559,21.813,25.125,27.523,6.51,4.226,23.754,13.476,27.523,14.618,1.142.343,5.824,1.827,10.164,3.426,7.423,2.512,10.507,3.426,26.952,8.108a46.341,46.341,0,0,0,8.565,1.827,72.106,72.106,0,0,1,9.593,1.6c15.075,3.426,24.668,5.253,27.18,5.253a60.828,60.828,0,0,1,9.707,1.6c10.849,2.512,23.64,4.568,24.211,3.883.8-.8-2.17-13.019-4.226-17.473C672.463,844.009,656.132,828.478,639,819.8c-2.855-1.37-5.939-2.969-6.852-3.426a143.993,143.993,0,0,0-14.275-6.167c-2.512-.914-6.624-2.4-9.136-3.426-27.637-10.164-75.031-15.417-91.933-10.164Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M428.3,819.684c-3.769,1.941-9.25,4.911-12.22,6.624C398.262,836.7,384.1,853.6,382.959,865.936l-.343,3.426,6.966.343c9.022.457,18.158-3.655,25.81-11.42,6.167-6.281,11.306-16.217,20.442-39.514C437.091,815.459,436.405,815.573,428.3,819.684Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('path', {
    staticStyle: {
      "fill": "#bea060"
    },
    attrs: {
      "d": "M465.413,820.484a148.39,148.39,0,0,0,5.6,14.961c.571,1.028,2.284,4.454,3.769,7.423,4.682,9.821,5.482,10.849,12.22,17.016,7.88,7.081,15.075,10.05,24.439,10.05h6.738l-.8-4.568a38.746,38.746,0,0,0-3.54-9.479c-1.485-2.627-3.2-5.824-3.769-7.081-2.512-5.71-19.072-18.958-33.461-26.723-10.507-5.71-12.562-5.939-11.192-1.6Z",
      "transform": "translate(-2.853 -5.493)"
    }
  }), _vm._v(" "), _c('circle', {
    staticStyle: {
      "fill": "none",
      "stroke": "#bea060",
      "stroke-miterlimit": "10"
    },
    attrs: {
      "cx": "448.147",
      "cy": "402.879",
      "r": "377.879"
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v("\n                Gewinnen  Sie eine Party für 50 Personen, eine BierKul-Tour durch Kulmbach\n                oder 50 Liter feinstes Zissel-Bier. Was Sie tun müssen? Einfach unsere Fragen\n                beantworten und abschicken! Wir drücken Ihnen die Daumen.\n            ")])]), _vm._v(" "), _c('section', {
    staticClass: "section--light form-container"
  }, [_c('div', {
    staticClass: "form-answer"
  }, [_c('div', {
    staticClass: "form-answer__content"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 50 50"
    }
  }, [_c('circle', {
    staticStyle: {
      "fill": "#d3bf92"
    },
    attrs: {
      "cx": "25",
      "cy": "25",
      "r": "25"
    }
  }), _c('polyline', {
    staticStyle: {
      "fill": "none",
      "stroke": "#1d1d1d",
      "stroke-width": "1",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "10"
    },
    attrs: {
      "points": "38,15 22,33 12,25 "
    }
  })]), _vm._v(" "), _c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "einkehren"
    }
  }, [_c('span', [_vm._v("Zurück zu Zissel")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    staticClass: "form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.showAnswer()
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "push",
      "mode": "out-in"
    }
  }, [(_vm.step === 1) ? _c('div', {
    key: "questions",
    staticClass: "form__questions"
  }, [_c('p', {
    staticClass: "large"
  }, [_vm._v("Zwei richtige Klicks und Sie sind dabei!")]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('p', [_vm._v("1. Wie lauten die Disziplinen des Bayron-Man 2010?")]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "disziplin-1",
      "type": "radio",
      "name": "disziplin",
      "value": "Schwimmen, Radfahren, Laufen"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disziplin-1"
    }
  }, [_vm._v("Schwimmen, Radfahren, Laufen")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "disziplin-2",
      "type": "radio",
      "name": "disziplin",
      "value": "Hammerwerfen, Hochseilklettern, Bäume sägen"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disziplin-2"
    }
  }, [_vm._v("Hammerwerfen, Hochseilklettern, Bäume sägen")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "disziplin-3",
      "type": "radio",
      "name": "disziplin",
      "value": "Fingerhakeln, Wetttrinken, Brezelwerfen"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "disziplin-3"
    }
  }, [_vm._v("Fingerhakeln, Wetttrinken, Brezelwerfen")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('p', [_vm._v("2. Wie heißt das neue Kult-Getränk von Zissel?")]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "kirsche",
      "type": "radio",
      "name": "getraenk",
      "value": "Zissel Kirsche"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "kirsche"
    }
  }, [_vm._v("Zissel Kirsche")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "lemon",
      "type": "radio",
      "name": "getraenk",
      "value": "Zissel Lemon"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lemon"
    }
  }, [_vm._v("Zissel Lemon")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "quitte",
      "type": "radio",
      "name": "getraenk",
      "value": "Zissel Quitte"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "quitte"
    }
  }, [_vm._v("Zissel Quitte")])])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.validateQuestions()
      }
    }
  }, [_vm._v("Weiter")]), _vm._v(" "), (_vm.showError) ? _c('p', {
    staticClass: "error"
  }, [_vm._v("Bitte alle Fragen beantworten.")]) : _vm._e()])]) : (_vm.step === 2) ? _c('div', {
    key: "address",
    staticClass: "form__address"
  }, [_c('p', [_vm._v("Vielen Dank für Ihre Antworten!"), _c('br'), _vm._v("\n                                Jetzt nur noch Ihre Adresse einfügen und "), _c('b', [_vm._v("gemütlich ein Zissel trinken.")])]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "surname",
      "name": "surname",
      "type": "text",
      "required": "",
      "placeholder": "Name"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "forename",
      "name": "forename",
      "type": "text",
      "required": "",
      "placeholder": "Vorname"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "email",
      "name": "email",
      "type": "text",
      "required": "",
      "placeholder": "E-Mail"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "phone",
      "name": "phone",
      "type": "text",
      "required": "",
      "placeholder": "Telefon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "street",
      "name": "street",
      "type": "text",
      "placeholder": "Straße"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "zip",
      "name": "zip",
      "type": "text",
      "placeholder": "Postleitzahl"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "city",
      "name": "city",
      "type": "text",
      "placeholder": "Ort"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form__item"
  }, [_c('input', {
    attrs: {
      "id": "age",
      "name": "age",
      "type": "text",
      "placeholder": "Alter"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('input', {
    attrs: {
      "id": "privacy",
      "name": "privacy",
      "type": "checkbox",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "privacy"
    }
  }, [_vm._v("Ich habe die "), _c('a', {
    attrs: {
      "href": "#0"
    }
  }, [_vm._v("Datenschutzrichtlinien")]), _vm._v(" gelesen und akzeptiert.")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "newsletter",
      "name": "newsletter",
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "newsletter"
    }
  }, [_vm._v("Ja, ich möchte weitere Informationen und abonniere den regelmäßigen Zissel-Newsletter.")])]), _vm._v(" "), _c('div', {
    staticClass: "form__group"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Senden")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "type": "reset"
    }
  }, [_vm._v("Zurücksetzen")]), _vm._v(" "), (_vm.showError) ? _c('p', {
    staticClass: "error"
  }, [_vm._v("Bitte füllen Sie die fehlenden Angaben aus. Danke.")]) : _vm._e()])]) : _vm._e()])], 1), _vm._v(" "), _vm._m(2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('small', [_vm._v("Mit Zissel auf der")]), _vm._v("\n                Gewinnerseite!\n            ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('span', {
    staticClass: "em"
  }, [_vm._v("Ein Fest ist ein Fest. Oder ein Zissel.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "txt-sm"
  }, [_vm._v("\n                    Der Rechtsweg ist ausgeschlossen."), _c('br'), _vm._v("\n                    Mitarbeiter und Angehörige der Brauerei Zissel sind vom Gewinnspiel ausgeschlossen.\n                    Einsendeschluss ist der 31.8.2010. Die Gewinner werden schriftlich benachrichtigt.\n                ")])
}]}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.popupShown) ? _c('div', {
    staticClass: "overlay transparent"
  }, [_c('div', {
    staticClass: "modal popup"
  }, [_c('span', {
    staticClass: "popup-close",
    on: {
      "click": function($event) {
        _vm.closePopup()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('header', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Mit Zissel auf der Gewinnerseite!")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('a', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.closePopupAndRedirect()
      }
    }
  }, [_c('span', [_vm._v("Hier geht’s zum"), _c('br'), _vm._v("\n                        Bayron-Man 2010-Gewinnspiel!")])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(8);


/***/ })
],[39]);


// WEBPACK FOOTER //
// main.576.js